import React, {useState, useEffect} from 'react'

import pill from "./../../../UI/general/pill.svg"

interface SidebaramenitiesMobileProps {
  amenitiesData: any,
  colorsData: any,
  handleamenitiesMenySelection: any,
  handleamenitiesFilter: any,
  amenitiesFilterId: string,
  handleOpenAmenitiesSpin: any,
  handleCloseAmenitieSpin: any
}
declare const window: any;

/*eslint-disable*/

const SidebaramenitiesMobile = ({
  amenitiesData, 
  colorsData, 
  handleamenitiesMenySelection,
  handleamenitiesFilter, 
  amenitiesFilterId,
  handleOpenAmenitiesSpin,
  handleCloseAmenitieSpin
}: SidebaramenitiesMobileProps) => {

  const [isamenitiesHidden, setamenitiesHidden] = useState(false)
  const [amenityIndex, setamenityIndex] = useState(-1)
  const [selectedamenityIndex, setSelectedamenityIndex] = useState(0)
  const [amenityOptionSelectedIndex, setamenityOptionSelectedIndex] = useState(-1)
  const [amenityOptionIndex, setamenityOptionIndex] = useState(-1)

  const [spinOpened, setSpinOpened] = useState(false)
  const [spinData, setSpinData] = useState()

  useEffect(() => {
    (async () => {
        var svgObj: any = document.querySelector('#selected-btn-amenities')
        if(svgObj){
            await fetch(svgObj.data)
            .then((response => response.blob()))
            .then((data) => {
                var url = URL.createObjectURL(data)
                svgObj.data = url
                svgObj.addEventListener('load', () => {
                    var svgDoc = svgObj.contentDocument
                    var paths = svgDoc.querySelectorAll('path')
                    paths.forEach((path: any) => {
                        path.setAttribute('fill',colorsData.secondary_text)
                    })
                    var defs = svgDoc.querySelectorAll('defs')
                    var svg = svgDoc.querySelector('svg')
                    svg.removeChild(defs[0])
                })
            })

        }
    })();
}, [selectedamenityIndex, amenitiesFilterId, colorsData]);

useEffect(() => {
  (async () => {
      var svgObjSpin: any = document.querySelector('#selected-btn-amenities-spin')
      if(svgObjSpin){
          await fetch(svgObjSpin.data)
          .then((response => response.blob()))
          .then((data) => {
              var url = URL.createObjectURL(data)
              svgObjSpin.data = url
              svgObjSpin.addEventListener('load', () => {
                  var svgDoc = svgObjSpin.contentDocument
                  if(svgDoc !== null){
                      var paths = svgDoc.querySelectorAll('path')
                      paths.forEach((path: any) => {
                          path.setAttribute('fill',colorsData.secondary_text)
                      })
                      var defs = svgDoc.querySelectorAll('defs')
                      var svg = svgDoc.querySelector('svg')
                      if(defs[0]){
                          svg.removeChild(defs[0])
                      }
                  }
              })
          })

      }
  })();
}, [spinOpened, colorsData]);

useEffect(() => {
    (async () => {
        var svgObj: any = document.querySelectorAll('#unselected-btn-amenities')
        if(svgObj){
            svgObj.forEach((obj: any) => {
                var svgDoc = obj.contentDocument
                var paths = svgDoc.querySelectorAll('path')
                paths.forEach((path: any) => {
                    path.setAttribute('fill',colorsData.main_text)
                })
            })
        }
    })();
}, [selectedamenityIndex, amenitiesFilterId, colorsData]);

useEffect(() => {
  if(spinOpened){
      handleOpenAmenitiesSpin(spinData)
  }
  else{
      handleCloseAmenitieSpin()
  }
}, [spinOpened,spinData, handleOpenAmenitiesSpin, handleCloseAmenitieSpin])

  return(
    <div className={isamenitiesHidden ? "amenities-sidebar-container-collapsed":"amenities-sidebar-container-opened"} style={{pointerEvents: "all"}}>
      <div className='hide-amenities-mobile-container' onClick = {() => {setamenitiesHidden(!isamenitiesHidden)}}>
        <img src={pill} alt=""></img>
      </div>
      {
        !isamenitiesHidden ?
        <div className='options-amenities-container-mobile'>
          <div className='options-amenities-name'>
            <img src={amenitiesData.icon} alt=""/>
            <div>Amenidades</div>
          </div>
          <div className='options-amenities-btns-container'>
            <div 
              className='options-amenity-individual-btn'
              style={{
                backgroundColor: selectedamenityIndex === 0 && amenitiesFilterId === "" ? colorsData.main_buttons : amenityIndex === 0 ? colorsData.secondary_buttons: "transparent",
                transition: "all 0.3s ease-in-out"
              }}
              onClick = {() => {
                  handleamenitiesFilter("", 0)
                  setSelectedamenityIndex(0) 
              }}
              >
              <div 
                className='options-amenity-individual-name'
                style={{
                  color: selectedamenityIndex === 0 && amenitiesFilterId === "" ? colorsData.secondary_text:colorsData.main_text
                }}
              >
                Ver todas
            </div>
            </div>
            {
              amenitiesData.menu.map((amenity: any, index: number) => 
                <div className='options-amenity-individual-btn'
                style = {{
                  backgroundColor: selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? colorsData.main_buttons : amenityIndex === index + 1 ? colorsData.secondary_buttons: 'transparent'
                }}
                onClick = {() => {
                    handleamenitiesFilter(amenity.id, amenity.mainFrame)
                    setSelectedamenityIndex(index + 1)
                    setSpinOpened(false)
                    selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? setSelectedamenityIndex(index + 1) : setamenityOptionSelectedIndex(-1)
                }}
                >
                   <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/")+amenity.icon.replace(' ', '+')} alt='' style={{filter: selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? 'invert(1) brightness(100%)':'none'}}></img>
                  <div 
                    className='options-amenity-individual-name'
                    style = {{
                      color: selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? colorsData.secondary_text: colorsData.main_text 
                    }}
                    >{amenity.name}</div>
                </div>
                
              )
            }
          </div>
        </div>:null
      }
      {
            ((selectedamenityIndex > 0) && !isamenitiesHidden && amenitiesData.menu[selectedamenityIndex - 1] && (amenitiesData.menu[selectedamenityIndex - 1].menu.length > 0 || amenitiesData.menu[selectedamenityIndex - 1].spinPortrait !== null) ) ?
            <div className='amenities-options-selection-menu-mobile'>
              {
                amenitiesData.menu[selectedamenityIndex - 1].menu.map((amenityMenu: any, index: number) => 
                  <div className='options-selection-menu-mobile-individual'
                  key={amenityMenu.name + index}
                  style={{
                      backgroundColor: amenityOptionIndex === index || amenityOptionSelectedIndex === index ? "#E0E0E0":'transparent'
                  }}
                  onClick = {() => {
                    //setamenityOptionSelectedIndex(indexamenity)
                    handleamenitiesMenySelection(amenityMenu)
                  }}
                  >
                    <img src={amenityMenu.icon} alt={""}/>
                    <div 
                      className='amenity-individual-name'
                      style = {{
                          color: colorsData.main_text
                      }}
                    >
                        {amenityMenu.name}
                    </div>
                  </div>
                )
              }
              {
                                                    amenitiesData.menu[selectedamenityIndex - 1].spinPortrait !== null ?
                                                    <div 
                                                            className='options-selection-menu-mobile-individual'
                                                            style={{
                                                                backgroundColor: spinOpened ? colorsData.main_buttons:'transparent',
                                                            }}
                                                            onClick = {() => {
                                                                setSpinOpened(!spinOpened)
                                                                setSpinData(amenitiesData.menu[selectedamenityIndex - 1].spinPortrait)
                                                            }}
                                                        >
                                                            <object type="image/svg+xml;utf8" data={'./UI/amenities/recorrido.svg'} className="svg-img" id = {spinOpened ? 'selected-btn-amenities-spin':'unselected-btn-amenities'}>.</object>
                                                            <div 
                                                                className='amenity-individual-name'
                                                                style = {{
                                                                    color: spinOpened ? colorsData.secondary_text:colorsData.main_text
                                                                }}
                                                            >
                                                                Spin {amenitiesData.menu[selectedamenityIndex - 1].spinPortrait.count_files === 25 ? '180º':'360º'}
                                                            </div>
                                                        </div>:null
                                                }
            </div>:null
      }
    </div>
  )
}

export default SidebaramenitiesMobile